import { Pipe, PipeTransform } from '@angular/core';

const PADDING = '000000';

@Pipe({
    name: 'prNumberPipe',
    standalone: false
})
export class PrNumberPipe implements PipeTransform {
  private DECIMAL_SEPARATOR: string;
  private THOUSANDS_SEPARATOR: string;

  constructor() {
    this.DECIMAL_SEPARATOR = '.';
    this.THOUSANDS_SEPARATOR = ' ';
  }

  transform(
    value: number | string,
    fractionSize: number = 2,
    handleFraction: boolean = true,
  ): string {
    let [integer, fraction = ''] = (value || '')
      .toString()
      .split(this.DECIMAL_SEPARATOR);

    if (fraction.length > 2) {
      fraction = fraction.slice(0, 2);
    }

    if (value.toString().endsWith(this.DECIMAL_SEPARATOR)) {
      fraction = this.DECIMAL_SEPARATOR;
    } else if (fraction !== '') {
      fraction = this.DECIMAL_SEPARATOR + fraction;
    }

    if (integer.length > 1 && integer[0] === '0') {
      integer = integer.slice(1, integer.length);
    }

    integer = integer.replace(/\s+/g, '');
    integer = integer.replace(
      /\B(?=(\d{3})+(?!\d))/g,
      this.THOUSANDS_SEPARATOR,
    );

    if (handleFraction) {
      fraction =
        fractionSize > 0
          ? this.DECIMAL_SEPARATOR +
            (fraction + PADDING).substring(0, fractionSize)
          : '';
    }

    if (value === 0) {
      return '0' + fraction;
    }

    if (integer === '') {
      return '';
    }

    return integer + fraction;
  }

  parse(value: string, fractionSize: number = 2): string {
    let [integer, fraction = ''] = (value || '').split(this.DECIMAL_SEPARATOR);

    integer = integer.replace(new RegExp(this.THOUSANDS_SEPARATOR, 'g'), '');

    fraction =
      parseInt(fraction, 10) > 0 && fractionSize > 0
        ? this.DECIMAL_SEPARATOR +
          (fraction + PADDING).substring(0, fractionSize)
        : '';

    return integer + fraction;
  }

  handleFraction(value: string, fractionSize: number): string {
    if (value === '') {
      return '';
    }

    let [integer, fraction = ''] = (value || '')
      .toString()
      .split(this.DECIMAL_SEPARATOR);

    fraction =
      fractionSize > 0
        ? this.DECIMAL_SEPARATOR +
          (fraction + PADDING).substring(0, fractionSize)
        : '';

    return integer + fraction;
  }
}
